"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRecommendedCatalogDateDataset = void 0;
var sdk_ui_kit_1 = require("@gooddata/sdk-ui-kit");
function getRecommendedCatalogDateDataset(dateDatasets) {
    var _a;
    var recommendedDateDataSetId = (_a = sdk_ui_kit_1.getRecommendedDateDataset(dateDatasets.map(function (ds) {
        return {
            id: ds.dataSet.id,
            title: ds.dataSet.title,
            relevance: ds.relevance,
        };
    }))) === null || _a === void 0 ? void 0 : _a.id;
    return recommendedDateDataSetId
        ? dateDatasets.find(function (ds) { return ds.dataSet.id === recommendedDateDataSetId; })
        : undefined;
}
exports.getRecommendedCatalogDateDataset = getRecommendedCatalogDateDataset;
//# sourceMappingURL=getRecommendedCatalogDateDataset.js.map